import styled from 'styled-components';

export const Message = styled.p`
  padding: var(--spacing-base);
  background: var(--grey-50);
  border-radius: var(--radius-base);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  color: var(--grey-700);
`;
